// extracted by mini-css-extract-plugin
module.exports = {"name":"formatters_name__1DUs2","name__link":"formatters_name__link__2UxEH","name__link__name":"formatters_name__link__name__201pa","quantity":"formatters_quantity__xhhd3"};